import { Spin } from 'antd';
import Activity from '@/shared/Activities/Activity';
import { StyledTaskActivityDetail } from './TaskActivityDetail.styled';
import TaskActivityNav from './TaskActivityNav/TaskActivityNav';
import ActivityTryFeedback from './ActivityTryFeedback/ActivityTryFeedback';
import useTaskActivityDetail from './useTaskActivityDetail.hook';
import Link from 'next/link';
import Button from '@/shared/Button/Button';
import Colors from '@/constants/Colors';
import IconWithTitle from '../IconWithTitle/IconWithTitle';

export default function TaskActivityDetail({
  taskId,
  taskActivityId,
  activityId,
  miniactivityConf,
  isPreview,
}) {
  const { state, actions } = useTaskActivityDetail({
    taskId,
    taskActivityId,
    activityId,
    miniactivityConf,
    isPreview,
  });

  return (
    <StyledTaskActivityDetail>
      <Spin spinning={state.loadingActivity}>
        {state.activity && (
          <div className="task-activity-container">
            <div className="activity-detail">
              <div className="activity-header">
                <IconWithTitle
                  title={state.activity.name}
                  subTitle={state.activity.englishName}
                  type={state.activity.type}
                  iconColor={Colors.activityTypeColors[state.activity.type]}
                />

                {isPreview ? null : (
                  <Link
                    href={`/student/dashboard`}
                    className="go-back-link"
                    passHref
                  >
                    <Button>Go back</Button>
                  </Link>
                )}
              </div>
              <div className="activity-container">
                <Activity
                  key={`${taskActivityId}${JSON.stringify(state.activityConf)}${
                    state.restartActivity
                  }`}
                  activity={state.activity}
                  activityConf={state.activityConf}
                  taskActivityConf={state.currentTaskActivity?.activityConf}
                  taskProgressActions={
                    state.activityConf && !isPreview
                      ? actions.taskProgressActions
                      : null
                  }
                  initialTaskProgress={state.initialTaskProgress}
                  isTaskActivityDone={state.isTaskActivityDone}
                />
                {state.savingProgress && !state.progressId && (
                  <div className="overlay">
                    <Spin />
                  </div>
                )}
              </div>
            </div>
            {isPreview ? null : (
              <div className="activity-nav">
                {state.showFeedback ? (
                  <ActivityTryFeedback
                    taskActivity={state.currentTaskActivity}
                    visible={state.showFeedback}
                    actions={actions.feedbackModalActions}
                    dueDate={state.dueDate}
                    savingProgress={state.savingProgress}
                    syncError={state.syncError}
                    taskProgress={state.taskProgress}
                  />
                ) : (
                  <div className="activity-nav-and-correctness">
                    <TaskActivityNav
                      taskActivities={state.taskActivities}
                      currentTaskActivityId={state.currentTaskActivity?.id}
                      currentActivityId={state.activity.id}
                      currentMiniactivityType={
                        state.activityConf?.miniactivityType
                      }
                      taskId={taskId}
                      dueDate={state.dueDate}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </Spin>
    </StyledTaskActivityDetail>
  );
}
